function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import ReactTagsInput from 'react-tagsinput';
import cx from 'classnames';

var TagsInput = function TagsInput(_ref) {
  var qaid = _ref.qaid,
      props = _objectWithoutProperties(_ref, ["qaid"]);

  return React.createElement("div", {
    id: qaid
  }, React.createElement(ReactTagsInput, _extends({
    className: cx('form-control TagsInput', {
      'TagsInput-disabled': props.disabled
    })
  }, props)));
};

TagsInput.displayName = 'TagsInput';
TagsInput.propTypes = {
  focusedClassName: PropTypes.string,
  addKeys: PropTypes.array,
  addOnBlur: PropTypes.bool,
  addOnPaste: PropTypes.bool,
  currentValue: PropTypes.string,
  inputValue: PropTypes.string,
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onChangeInput: PropTypes.func,
  removeKeys: PropTypes.array,
  renderInput: PropTypes.func,
  renderTag: PropTypes.func,
  renderLayout: PropTypes.func,
  pasteSplit: PropTypes.func,
  tagProps: PropTypes.object,
  onlyUnique: PropTypes.bool,
  value: PropTypes.array.isRequired,
  maxTags: PropTypes.number,
  validationRegex: PropTypes.instanceOf(RegExp),
  disabled: PropTypes.bool,
  tagDisplayProp: PropTypes.string,
  qaid: PropTypes.string
};
TagsInput.defaultProps = {
  focusedClassName: 'TagsInput-focused',
  inputProps: {
    className: 'TagsInput-input',
    placeholder: ''
  },
  tagProps: {
    className: 'TagsInput-tag',
    classNameRemove: 'TagsInput-remove'
  }
};
export default TagsInput;